import { GestationalAge } from "@/Patient/Models/ObstetricalFile/GestationalAge";

class BritishColumbiaObstetricalFileEdinburghPerinatalSection14 {
    public Declined?: boolean;
    public Date: Date;
    public GestationalAge: GestationalAge;
    public EdinburghTotalScore?: number;
    public AnxietySubScore?: number;
    public SelfHarmSubScore?: number;
    public FollowUp: string;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFileEdinburghPerinatalSection14>) {
        Object.assign(this, fields);

        this.GestationalAge = new GestationalAge(fields?.GestationalAge);
    }
}

export { BritishColumbiaObstetricalFileEdinburghPerinatalSection14 };
